import React from "react";
import classnames from "classnames";

const ProgressBar = ({ className, progress, reverse }) => {
  const classes = classnames("progressBar", className);

  return (
    <div
      className={classes}
      role="progressbar"
      aria-valuenow={progress || 1}
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div style={{ width: `${progress || 1}%` }} />
    </div>
  );
};

export default ProgressBar;
